//#region Imports

import { Injectable, OnDestroy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription, filter, pairwise } from 'rxjs';

//#endregion

@Injectable({
  providedIn: 'root'
})
export class GlobalSpinnerService implements OnDestroy {
  constructor(private readonly router: Router) {}

  //#region Private Properties

  protected isLoading = false;

  private routerEventSubscription?: Subscription;

  private lastUrl?: string;

  private keepLoading = false;

  private showSpinnerTimer?: ReturnType<typeof setTimeout>;

  private readonly showSpinnerDelayMs = 250;

  //#endregion

  //#region Public Methods

  public ngOnDestroy(): void {
    this.clearShowSpinnerTimer();
    this.routerEventSubscription?.unsubscribe();
  }

  public initialize(): void {
    this.routerEventSubscription = this.router.events.subscribe((event: unknown) => {
      if (this.keepLoading) return;

      if (event instanceof NavigationStart) this.scheduleSpinner();
      else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) this.finishNavigationSpinner();
    });
  }

  public showSpinner(): void {
    this.keepLoading = true;

    if (!this.isLoading) this.startSpinner();
  }

  public hideSpinner(): void {
    this.keepLoading = false;

    if (this.isLoading) this.endSpinner();
  }

  private scheduleSpinner(): void {
    this.clearShowSpinnerTimer();
    this.showSpinnerTimer = setTimeout(() => {
      this.showSpinnerTimer = undefined;
      if (!this.keepLoading) this.startSpinner();
    }, this.showSpinnerDelayMs);
  }

  private finishNavigationSpinner(): void {
    this.clearShowSpinnerTimer();
    this.endSpinner();
  }

  private clearShowSpinnerTimer(): void {
    if (this.showSpinnerTimer !== undefined) {
      clearTimeout(this.showSpinnerTimer);
      this.showSpinnerTimer = undefined;
    }
  }

  private startSpinner(): void {
    this.isLoading = true;
    const spinnerElement = document.getElementById('main-loading');

    if (spinnerElement) {
      spinnerElement.classList.add('!flex');
      spinnerElement.classList.add('!opacity-100');
    }
  }

  private endSpinner(): void {
    const spinnerElement = document.getElementById('main-loading');

    if (spinnerElement) {
      spinnerElement.classList.remove('!flex');
      spinnerElement.classList.remove('!opacity-100');
    }

    this.isLoading = false;
  }

  //#endregion
}
